<template>
  <div class="row justify-content-between">
    <div class="col media">
      <img
        v-if="vehicle.image"
        :src="vehicle.image.url"
        :alt="vehicle.name"
        class="mr-3"
      />
      <div class="media-body text-lg">
        <p>{{ vehicle.name }}</p>
        <p>
          <i class="icon-man"></i>
          {{ vehicle.seats }} {{ $t('vehicles.passengers') }}
        </p>
        <p>
          <i class="icon-briefcase3"></i>
          {{ vehicle.luggage }} {{ $t('vehicles.luggage') }}
        </p>
        <p>
          <i class="icon-portfolio"></i>
          {{ vehicle.small_luggage }} {{ $t('vehicles.small_luggage') }}
        </p>
      </div>
    </div>
    <div v-if="sharingVehicle" class="col align-self-center flex-grow-0">
      <i class="icon-arrow-right8"></i>
    </div>
    <div v-if="sharingVehicle" class="col media mt-0">
      <img
        v-if="sharingVehicle.image"
        :src="sharingVehicle.image.url"
        :alt="sharingVehicle.name"
        class="mr-3"
      />
      <div class="media-body text-lg">
        <p>{{ sharingVehicle.name }}</p>
        <p>
          <i class="icon-man"></i>
          {{ sharingVehicle.seats }} {{ $t('vehicles.passengers') }}
        </p>
        <p>
          <i class="icon-briefcase3"></i>
          {{ sharingVehicle.luggage }} {{ $t('vehicles.luggage') }}
        </p>
        <p>
          <i class="icon-portfolio"></i>
          {{ sharingVehicle.small_luggage }} {{ $t('vehicles.small_luggage') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vehicle: {
      required: true,
      type: Object,
    },
    sharingVehicle: {
      type: Object,
      default() {
        return null
      },
    },
  },
}
</script>
